import { Component, Input } from '@angular/core';

@Component({
  selector: 'boi-case-layout-container',
  templateUrl: './case-layout-container.component.html',
  styleUrls: ['./case-layout-container.component.scss']
})
export class CaseLayoutContainerComponent {
  @Input() hasRightSidePanel = true;
}
